export const environment = {
  production: false,
  basePath: 'https://micabdev.mi2.in/api',
  tenant: 'tenantIdForTaxiPulse000000000001',
  supportedCountry: ['IN', 'UK', 'US'],
  firebase: {
    apiKey: "AIzaSyCUd-57GOUc5GO1_8Gjzo2IxKoDB2vt0cI",
    authDomain: "taxipulse-micabdev.firebaseapp.com",
    databaseURL: "https://taxipulse-micabdev.firebaseio.com",
    projectId: "taxipulse-micabdev",
    storageBucket: "taxipulse-micabdev.firebasestorage.app",
    messagingSenderId: "621841500144",
    appId: "1:621841500144:web:34a51876afe1db6ca47f35"
  }
};
